import React, { useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { getDate } from "utils/formatDate";
import { formatNumber } from "utils/currencyFormat";

const InDanhSachBanHang = ({ show, onHide, listData, isPrint = false, listUserName }) => {
    const printRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        documentTitle: `Bán hàng | Phần mềm quản lý tài chính`, 
        onAfterPrint: onHide,
    });
    useEffect(() => {
        if (show && listData?.length > 0 && isPrint) {
            handlePrint();
        }
    }, [show, listData, isPrint]);

    if (!show) return null;
    return (
        <div style={{ display: 'none' }}>
            <div ref={printRef} id="tblExcelBanHang" style={{ 
                padding: "30px",
                width: "100%",
            }}>
                <table
                    border="1"
                    className="table-bordered"
                    style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        fontFamily: "Arial",
                        fontSize: "13px",
                        color: "#000",
                    }}
                >
                    <thead>
                        <tr>
                            <th colSpan="7" style={{ 
                                fontSize: "18px",
                                border: "1px solid #000",
                                textAlign: "center",
                                padding: "8px 0",
                            }}>
                                Danh sách đơn bán hàng 
                            </th>
                        </tr>

                        <tr style={{ backgroundColor: "#f2f2f2" }}>
                            <th>STT</th>
                            <th style={{ textAlign: "center" }}>Mã</th>
                            <th>Tên khách hàng</th>
                            <th style={{ textAlign: "right" }}>Tiền đơn hàng</th>
                            <th style={{ textAlign: "right" }}>Tiền thanh toán</th>
                            <th>Nhân viên</th>
                            <th>Thời gian</th>
                        </tr>
                    </thead>

                    <tbody>
                        {listData?.map((item, idx) => {
                            return (
                                <tr key={idx}>
                                    <td style={{ textAlign: "center" }}>{idx + 1}</td>
                                    <td style={{ textAlign: "left" }}>{item.OrderCode}</td>
                                    <td>{item.CustomerName}</td>
                                    <td style={{ textAlign: "right" }}>
                                        {formatNumber(Math.round(item.TotalAmount ?? 0))}
                                    </td>
                                    <td style={{ textAlign: "right" }}>

                                        {formatNumber(Math.round(item.TotalPaid ?? 0))}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        {(() => {
                                            const user = listUserName.find(u => u.value === item.CreatedUser);
                                            return user ? user.label : "" || "";
                                        })()}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        {getDate(item.CreatedDate)}
                                    </td>
                                </tr>
                            )
                        })
                        }
                    </tbody>
                </table>
                <style>
                    {`
                        @media print {
                            body > * {
                                display: none !important;
                            }
                            #tblExcelBanHang { /* Đổi ID */
                                display: block !important;
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: 100%;
                            }
                        }
                        
                        .table-bordered th, .table-bordered td {
                            border: 1px solid #000;
                            padding: 5px;
                            vertical-align: top;
                        }
                        .table-bordered th {
                            background-color: #e8f5e9;
                        }
                        .table-bordered {
                            border: 1px solid #000;
                        }
                        @page {
                            size: A4 portrait;
                            margin: 20mm 10mm 20mm 10mm;
                        }
                        @media print {
                            body {
                                -webkit-print-color-adjust: exact;
                                print-color-adjust: exact;
                            }
                        }
                    `}
                </style>
            </div>
        </div>
    );
};

export default InDanhSachBanHang;